import { Input, Select } from "antd"
import React, { useRef } from "react"
import CustomRangePicker from "src/components/CustomRangePickerMobile/CustomRangePicker"
import Button from "src/components/MyButton/Button"
import SvgIcon from "src/components/SvgIcon"
import { InputSearchStyle } from "../../Setting/common/styled"
import SelectProvider from "src/components/Dropdown/SelectProvider"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import SelectCustomer from "src/components/Dropdown/SelectCustomer"

const FilterOrder = ({ setFilter, setKeyword, tabStatus }) => {
  const inputSearchRef = useRef()
  const onSearch = () => {
    const keyword = inputSearchRef.current || ""
    setKeyword(keyword)
  }
  const onClearSearch = () => {
    inputSearchRef.current = ""
    setKeyword("")
  }
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 16,
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          maxWidth: "1000px",
        }}
      >
        <SelectCustomer
          type={"LEADER"}
          placeholder={"Chọn khách hàng"}
          style={{ width: 200 }}
          onChange={val => setFilter(prev => ({ ...prev, customer_id: val }))}
          level={0}
        />

        <CustomRangePicker
          style={{ width: 250 }}
          format="DD/MM/YYYY"
          onChange={dates => {
            const [start, end] = dates || []
            setFilter(prev => ({
              ...prev,
              start_date: start?.format("YYYY-MM-DD"),
              end_date: end?.format("YYYY-MM-DD"),
            }))
          }}
        />
      </div>
      <div>
        <InputSearchStyle>
          <Input
            className="custom-input"
            maxLength={50}
            placeholder="Tìm kiếm theo mã đơn hàng"
            onChange={e => (inputSearchRef.current = e.currentTarget.value)}
            onPressEnter={onSearch}
            onClear={onClearSearch}
            size="small"
          />
          <div className="custom-icon-search">
            <SvgIcon name="searchStatistic" onClick={onSearch} />
          </div>
        </InputSearchStyle>
      </div>
    </div>
  )
}
export default FilterOrder
